import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import FeesBreakdown from '../fees-breakdown';
import LinkWithPopover from '../link-with-popover';
import money, { Money, format } from '../../lib/money';
import '../../css/share-details.css';

class MaximumAllowedShare extends Component {
  get amount() {
    return money(this.props.amount);
  }

  get feesAmount() {
    return money(this.props.feesAmount);
  }

  showingDetails() {
    return this.feesAmount &&
      this.feesAmount.isGreaterThan(Money.zero(this.feesAmount.currencyCode));
  }

  renderFeesBreakdownDetails() {
    if (!this.showingDetails()) return null;

    return (
      <LinkWithPopover name="fees-breakdown" text="Details" className="small-print">
        <FeesBreakdown
          title={
            <FormattedMessage
              id="maximumAllowedShare.feesBreakdown.title"
              defaultMessage="Details"
            />
          }
          headers={[
            <FormattedMessage
              id="maximumAllowedShare.feesBreakdown.headers.description"
              defaultMessage="Description"
            />,
            <FormattedMessage
              id="maximumAllowedShare.feesBreakdown.headers.amount"
              defaultMessage="Max Amount"
            />
          ]}
          claimedSlots={this.props.claimedSlots}
          amount={this.amount}
          shareAmount={this.props.shareAmount}
          costPerSlot={this.props.costPerSlot}
          feesAmount={this.feesAmount}
        />
      </LinkWithPopover>
    );
  }

  render() {
    return (
      <div className="share-details pl-2 py-1">
        <h4>
          <FormattedMessage
            id="maximumAllowedShare.title"
            defaultMessage="Maximum allowed share"
          />
          <br />
          <span className="small-print">
            <FormattedMessage
              id="maximumAllowedShare.description"
              defaultMessage="As a portion of group's total."
            />
          </span>
        </h4>
        <div>
          <b>{format(this.amount)}</b>
          {' '}
          {this.renderFeesBreakdownDetails()}
        </div>
      </div>
    );
  }
}


MaximumAllowedShare.defaultProps = {
  claimedSlots: 1,
  amount: null,
  shareAmount: null,
  feesAmount: null,
  costPerSlot: null,
};


export default MaximumAllowedShare;



// WEBPACK FOOTER //
// ./src/desktop/components/commit-form/maximum-allowed-share.js